import moment from 'moment';
import Api from '../Api';
import { parseUnits, formatHash } from '../utils';
import { closeModal } from '../modal';

export function createApp(selector) {
    PetiteVue.createApp({
        coin: "bch",
        search: "",

        searchWallet() {
            document.location = "/miner/" + this.coin + '/' + this.search;
        },

        setThemeMode(theme) {
            document.body.setAttribute("data-bs-theme", theme);
        }
    }).mount(selector);
}